/* eslint-disable no-console */

const SET_IS_ZOOM_APP = 'SET_IS_ZOOM_APP'

const _state = {
  isZoomApp: sessionStorage.getItem('zoomApp') == 'true',
}

const getters = {
  isZoomApp(state) {
    return state.isZoomApp
  },
}

const actions = {
  setIsZoomAppAction({ commit }, isReady) {
    commit(SET_IS_ZOOM_APP, isReady)
  },
}

const mutations = {
  [SET_IS_ZOOM_APP](state, isZoomApp) {
    state.isZoomApp = isZoomApp
    sessionStorage.setItem('zoomApp', 'true')
  },

}

const zoomApp = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default zoomApp
